import { track } from '@spotify-internal/track-js';

const GOOGLE_TAG_MANAGER_ID = 'GTM-K9P8ZQ';

export const GA_CATEGORIES = {
  CONTACT_FORM: 'contact-form',
};

class Analytics {
  initialized = false;
  market?: string;

  async initialize(market: string) {
    if (this.initialized) return;

    this.market = market;
    await track({
      googleTagManagerId: GOOGLE_TAG_MANAGER_ID,
      market: this.market,
      oneTrust: process.env.USE_COOKIE_BANNER === 'true',
    });
    this.initialized = true;
  }

  trackExperiment(identifier: string) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'experimentidpush',
      experimentIdentifier: identifier,
    });
  }

  trackVirtualPageView(page = '') {
    window.dataLayer = window.dataLayer || [];

    // replaces "/ca-fr/" with "/" for instance
    const pageWithoutMarket = page.replace(/^\/\w{2}(-\w{2})?\//, '/');

    window.dataLayer.push({
      event: 'virtualPageview',
      market: this.market,
      virtualPageURL: pageWithoutMarket,
      virtualPageTitle: document.title,
    });
  }

  trackEvent({ category = '', action = '', label = '', value = 0, nonInteraction = false }) {
    window.dataLayer = window.dataLayer || [];

    // Send all events to GTM
    window.dataLayer.push({
      event: 'genericEvent',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventValue: value,
      nonInteraction,
    });
  }
}

export default new Analytics();
